module.exports = __webpack_public_path__ + "static/img/default.dfb67a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default.jpg
// module id = TqZG
// module chunks = 1